import React from 'react'
import styled from 'styled-components'
import ResetPasswordForm from '../components/ResetPasswordForm'
import colors from "../../../constants/colors"

const S = {
    PageWrapper: styled.div`
        min-height: 100vh;
        background-color: ${colors.lightBackground};
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    `,
    Container: styled.div`
        background-color: white;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        padding: 40px;
        width: 100%;
        max-width: 500px;
    `,
}

const ResetPasswordPage = () => (
    <S.PageWrapper>
        <S.Container>
            <ResetPasswordForm />
        </S.Container>
    </S.PageWrapper>
)

export default ResetPasswordPage
